import React from 'react';
import '../styles/Profile.css';

const Profile = () => {
    const user = {
        name: "Giridharan S",
        email: "giridharans1729@gmail.com",
        phone: "+91 93616 09946",
        location: "India",
        username: "GiridharanS1729",
        joinedDate: "2024-10-22",
        image: "/imgs/dp.png",
    };

    return (
        <div className="profile">
            <div className="profile-container">
                <div className="profile-top">
                    <img src={user.image} alt="Profile" className="profile-image" />
                    <div className="profile-info">
                        <h1 className="profile-name">{user.name}</h1>
                        <p className="profile-username">@{user.username}</p>
                    </div>
                </div>
                <div className="profile-bottom">
                    <div className="profile-details-left">
                        <p><span className="profile-label">Name</span></p>
                        <p><span className="profile-label">Mail</span></p>
                        <p><span className="profile-label">Phone number</span></p>
                        <p><span className="profile-label">Location</span></p>
                    </div>
                    <div className="profile-details-right">
                        <p><span className="profile-label"></span> {user.name}</p>
                        <p><span className="profile-label"></span> {user.email}</p>
                        <p><span className="profile-label"></span> {user.phone}</p>
                        <p><span className="profile-label"></span> {user.location}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
